import { render } from "./TableComp.vue?vue&type=template&id=769f0b73"
import script from "./TableComp.vue?vue&type=script&lang=js"
export * from "./TableComp.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\user\\Desktop\\RA\\RCN\\rcn_site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__